import { NavLink } from 'react-router-dom'
import { ComponentWithAs, Flex, HStack, StyleProps, Text, TextProps } from '@chakra-ui/react'
import { themeColors } from 'theme'

import { IconPropsType } from 'components/SVGS'

export interface CustomNavLinkProps extends StyleProps {
  children: ComponentWithAs<'p', TextProps>
  icon: React.FC<IconPropsType>
  route: string
  gradient: string
}

const CustomNavLink: React.FC<CustomNavLinkProps> = ({ children, route, icon: IconCustom, gradient, ...rest }) => {
  const { drawer: { bgColor, bgActiveColor } } = themeColors

  return (
    <NavLink to={route} style={{ width: '100%' }}>
      {({ isActive }) => (
        <HStack justifyContent={'flex-start'} alignItems={'center'} bgGradient={isActive ? gradient : ''} {...rest}>
          <Flex w={10} h={10}
            bg={isActive ? bgColor : bgActiveColor}
            rounded='lg'
            alignItems='center'
            color={isActive ? bgActiveColor : bgColor}
            justifyContent='center'>
            <IconCustom fill={isActive ? bgActiveColor : bgColor} size={7} />
          </Flex>
          <Text color={isActive ? bgColor : bgActiveColor}>{children}</Text>
        </HStack>
      )}
    </NavLink>
  )
}

export default CustomNavLink
